<div class="bmc-package-search-container" *ngIf="(catalogObjects && catalogObjects.length > 0) || (searchText$ | async)">
    <div class="bmc-package-search-container__list">
        <biz-package-visualizer-list *ngIf="catalogObjects && catalogObjects.length"
            [isSearchMode]="true"
            [catalogObjects]="catalogObjects"
            [searchText]="(searchText$ | async)"
            [isLoading]="(isLoadingList$ | async)"
            class="bz-space--inline-l bmc-package-search-container__list-search">
        </biz-package-visualizer-list>
        <div class="bmc-package-search-container-empty"
          *ngIf="!catalogObjects.length">
          <div class="bmc-package-search-container-empty__img">
          </div>
          <div class="bmc-package-search-container-empty__text">
            <span class="bz-color--theme-400 bz-font-size--subheading">{{'DEPLOYMENT.SEARCH_RESULTS' | translate}}</span>
            <span class="bz-font-size--body-small">{{'PACKAGE_VISUALIZER.EMPTY_SEARCH_CATALOG' | translate}}</span>
          </div>
        </div>
        <biz-package-visualizer-filters (onFilterOptionsChange)="filterPackageSummary($event)">
        </biz-package-visualizer-filters>
    </div>
</div>
<div class="bmc-package-search-container-empty" *ngIf="(!catalogObjects || catalogObjects.length === 0) && !(searchText$ | async)">
    <div class="bmc-package-search-container-empty__img">
    </div>
    <div class="bmc-package-search-container-empty__text">
        <span class="bz-color--theme-400 bz-font-size--subheading">{{'DEPLOYMENT.SEARCH_EMPTY_1' | translate}}</span>
        <span class="bz-font-size--body-small">{{'DEPLOYMENT.SEARCH_EMPTY_2' | translate}}</span>
    </div>
</div>
